import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { withRouter, useHistory } from 'react-router-dom';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { Modal } from 'syngenta-digital-cropwise-react-ui-kit';
import UiKitButton from 'components/UiKit/Button';
import { equipment as equipmentApi } from 'utilities/api';
import catchCancel from 'helpers/catchCancel';
import { parseServerError } from 'helpers/errorHelpers';
import { Context } from 'components/Store';
import { AmplitudeContext } from 'utilities/amplitude/useAmplitude';
import { paths } from 'routes/paths';
import 'screens/Equipment/equipment.css';

const deleteEquipmentModalDefaultPropEquipments = [{}];
const deleteEquipmentModalDefaultPropSetItems = () => {};
const DeleteEquipmentModal = ({
  open,
  close,
  equipmentName = '',
  equipmentId = '',
  setItems = deleteEquipmentModalDefaultPropSetItems,
  equipments = deleteEquipmentModalDefaultPropEquipments,
  label = ''
}) => {
  const history = useHistory();
  const [isSaving, setIsSaving] = useState(false);
  const amplitude = useContext(AmplitudeContext);
  const [, dispatch] = useContext(Context);
  const handleDelete = async () => {
    let newEquipmentList = [];
    if (label !== 'view') {
      newEquipmentList = equipments.filter(
        eachItem => eachItem.id !== equipmentId
      );
    }
    // amplitude trigger
    amplitude.sendEventToAmplitude(
      amplitude.events.epic.Equipment.deleteEquipment
    );
    setIsSaving(true);
    try {
      const { promise } = equipmentApi.delete(equipmentId);
      await promise;
      if (label === 'view') {
        history.replace({
          pathname: paths.equipment
        });
      } else {
        setItems(newEquipmentList);
      }
      close();
    } catch (error) {
      await Promise.reject(error)
        .catch(catchCancel)
        .catch(parseServerError(dispatch));
    } finally {
      setIsSaving(false);
    }
  };

  const actionPerformed = 'Delete "';
  const closeQuote = '"';

  return (
    <Modal
      open={open}
      onCancel={close}
      closable={false}
      width={512}
      centered
      destroyOnClose
      transitionName="syt-antd-fade"
      footer={null}
      className="equipment-delete-modal"
      aria-labelledby="equipment-delete-modal-title"
    >
      <div className="equipment-delete-modal-header">
        <ErrorOutlineIcon
          data-testid="error-icon"
          style={{ color: '#ef4444' }}
        />
        <h3 id="equipment-delete-modal-title">
          {actionPerformed + equipmentName + closeQuote}
        </h3>
      </div>
      <div className="equipment-delete-modal-content">
        You are about to permanently delete this equipment item. This cannot be
        undone. Are you sure you want to proceed?
      </div>
      <div className="equipment-delete-modal-actions">
        <UiKitButton variant="outline" onClick={close}>
          Cancel
        </UiKitButton>
        <UiKitButton
          variant="primary"
          danger
          onClick={handleDelete}
          disabled={isSaving}
          loading={isSaving}
        >
          Delete
        </UiKitButton>
      </div>
    </Modal>
  );
};

DeleteEquipmentModal.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  equipmentName: PropTypes.string,
  equipmentId: PropTypes.string,
  setItems: PropTypes.func,
  equipments: PropTypes.arrayOf(PropTypes.object),
  label: PropTypes.string
};

export default withRouter(DeleteEquipmentModal);
